export default "__VITE_ASSET__44f669e3__"